import { DraftPreviewProvider } from './DraftPreviewProvider';
import { Root } from './Root';
export function DraftPreview(props) {
    const { composerId, initialParentId, onClose, onGoBack } = props;
    return (<DraftPreviewProvider composerId={composerId} initialParentId={initialParentId} onClose={onClose} onGoBack={onGoBack}>
      <Root />
    </DraftPreviewProvider>);
}
